const LY_ADS_CLICK_ID_QUERY_PARAM = '_ly_c';

let capturedLyAdsClickID: string | undefined;

function readLyAdsClickIDForTracker(): string | undefined {
  return (
    new URLSearchParams(window.location.search).get(
      LY_ADS_CLICK_ID_QUERY_PARAM,
    ) ?? undefined
  );
}

export function getCapturedLyAdsClickID(): string | undefined {
  return capturedLyAdsClickID;
}

export async function fireYahooAdsPageViewAfterLiffReady(): Promise<void> {
  // LY Ads reads click ID params from the current URL when the tag fires.
  // Wait for LIFF initialization to finish so the LIFF redirect flow has settled.
  const tagId = process.env.YAHOO_ADS_TRACKING_TAG_ID;
  const lytag = window.lytag;

  if (!tagId || typeof lytag !== 'function') {
    capturedLyAdsClickID = undefined;
    return;
  }

  const liffReady = window.liff?.ready;

  if (!liffReady || typeof liffReady.then !== 'function') {
    capturedLyAdsClickID = undefined;
    console.warn(
      'Skipping Yahoo Ads page view because liff.ready is unavailable.',
    );
    return;
  }

  try {
    await Promise.resolve(liffReady);
  } catch (error: unknown) {
    capturedLyAdsClickID = undefined;
    console.warn(
      'Skipping Yahoo Ads page view because liff.ready rejected.',
      error,
    );
    return;
  }

  // Read immediately before `lytag(init)` so the game stores the same
  // top-level URL click ID value the LY Ads tracker is about to read.
  const lyAdsClickID = readLyAdsClickIDForTracker();

  try {
    lytag({
      type: 'init',
      tagId,
      config: { useCookie: true, useLocalStorage: true },
    });
    capturedLyAdsClickID = lyAdsClickID;
  } catch (error: unknown) {
    capturedLyAdsClickID = undefined;
    console.warn(
      'Skipping Yahoo Ads page view because lytag init failed.',
      error,
    );
    return;
  }

  try {
    lytag({
      type: 'event',
      eventType: 'page_view',
      tagId,
    });
  } catch (error: unknown) {
    console.warn(
      'Skipping Yahoo Ads page view because lytag event failed.',
      error,
    );
  }
}
